/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { License } from '../../core/models/common/License';

/**
 * Constructor.
 * @class
 * @extends License
 * @author eric.wittmann@gmail.com
 */
export abstract class OasLicense extends License {
    public constructor() {
        super();
    }
}
OasLicense["__class"] = "io.apicurio.datamodels.openapi.models.OasLicense";
OasLicense["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




